if (!customElements.get('product-wellness-form')) {
  customElements.define(
    'product-wellness-form',
    class ProductWellnessForm extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('[data-add-to-cart]');
        if (!this.submitButton) return;

        this.onSubmitHandler = this.onSubmit.bind(this);
        this.submitButton.addEventListener('click', this.onSubmitHandler);

        // Attach remove listener once globally
        if (!window.__wellnessRemoveAttached) {
          document.addEventListener('click', this.handleCartRemove.bind(this));
          window.__wellnessRemoveAttached = true;
        }
      }

      disconnectedCallback() {
        if (this.submitButton) {
          this.submitButton.removeEventListener('click', this.onSubmitHandler);
        }
      }

      // -----------------------------
      // Get selected child products
      // -----------------------------
      getSelectedItems() {
        const inputs = this.querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        );

        return Array.from(inputs).map((input) => ({
          id: parseInt(input.value),
          quantity: 1
        }));
      }

      // -----------------------------
      // ADD TO CART FLOW
      // -----------------------------
      async onSubmit(e) {
        e.preventDefault();

        const selectedItems = this.getSelectedItems();

        if (!selectedItems.length) {
          alert('Please select at least Two product');
          return;
        }

        const mainProductId = parseInt(
          this.querySelector('.product-variant-id')?.value
        );

        if (!mainProductId) return;

        this.setLoading(true);

        try {
          // 1️⃣ Add CHILDREN first (with parent_id)
          const childItems = selectedItems.map((item) => ({
            id: item.id,
            quantity: 1,
            properties: {
              parent_id: String(mainProductId),
              ptype: "subproduct"
            }
          }));

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: childItems })
          });

          // 2️⃣ Add PARENT last (so it appears first in cart)
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: mainProductId, quantity: 1 }]
            })
          });

          // 3️⃣ Redirect to cart page
          window.location.href = '/cart';
        } catch (error) {
          console.error('Cart Error:', error);
          alert('Failed to add items to cart. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }

      // -----------------------------
      // REMOVE PARENT + CHILDREN
      // -----------------------------
      async handleCartRemove(e) {
        const removeBtn = e.target.closest('cart-remove-button');
        if (!removeBtn) return;

        e.preventDefault();

        try {
          // Fetch current cart
          const cart = await fetch('/cart.js').then(res => res.json());

          // Find the DOM element of the clicked cart item
          const clickedEl = removeBtn.closest('[data-cart-item]');
          if (!clickedEl) return;

          // Shopify cart line numbers start at 1
          const lineNumber = parseInt(clickedEl.dataset.lineItem);
          if (!lineNumber) return;

          const parentItem = cart.items[lineNumber - 1];
          if (!parentItem) return;

          const parentId = String(parentItem.id);

          // Build updates object for cart items to remove
          const updates = {};

          cart.items.forEach((item, index) => {
            const line = index + 1; // Shopify lines start at 1
            const isParent = item.id === parentItem.id;
            const isChild = item.properties?.parent_id === parentId;

            if (isParent || isChild) {
              updates[line] = 0;
            }
          });

          // Send update request
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });

          // Reload cart page
          window.location.reload();
        } catch (err) {
          console.error('Remove failed:', err);
          alert('Failed to remove items from cart. Please try again.');
        }
      }

      // -----------------------------
      // LOADING STATE
      // -----------------------------
      setLoading(state) {
        if (!this.submitButton) return;
        this.submitButton.disabled = state;
        this.submitButton.classList.toggle('loading', state);
      }
    }
  );
}
/*if (!customElements.get('product-wellness-form')) {
  customElements.define(
    'product-wellness-form',
    class ProductWellnessForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-add-to-cart]');

        if (!this.form || !this.submitButton) return;

        this.onSubmitHandler = this.onSubmit.bind(this);
        this.submitButton.addEventListener('click', this.onSubmitHandler);

        // ✅ Attach remove listener once
        if (!window.__wellnessRemoveAttached) {
          document.addEventListener('click', this.handleCartRemove.bind(this));
          window.__wellnessRemoveAttached = true;
        }
      }

      disconnectedCallback() {
        if (this.submitButton) {
          this.submitButton.removeEventListener('click', this.onSubmitHandler);
        }
      }

      getSelectedItems() {
        const inputs = this.querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        );

        return Array.from(inputs).map((input) => ({
          id: parseInt(input.value),
          quantity: 1
        }));
      }

      async onSubmit() {
        const selectedItems = this.getSelectedItems();

        if (!selectedItems.length) {
          alert('Please select at least one product');
          return;
        }

        const mainProductId = parseInt(
          this.querySelector('.product-variant-id')?.value
        );

        this.setLoading(true);

        try {
          // ✅ 1. Add parent
          const parentRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: mainProductId, quantity: 1 }]
            })
          });

          if (!parentRes.ok) throw new Error('Parent add failed');

          const parentData = await parentRes.json();
          const parentId = parentData.items?.[0]?.id || mainProductId;

          // ✅ 2. Add children
          const childItems = selectedItems.map(item => ({
            id: item.id,
            quantity: 1,
            properties: {
              parent_id: parentId
            }
          }));

          const childRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: childItems })
          });

          if (!childRes.ok) throw new Error('Child add failed');

          await childRes.json();

          this.refreshCartDrawer();

        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.setLoading(false);
        }
      }

      // ✅ Auto-remove children when parent is removed
      async handleCartRemove(e) {
        const removeBtn = e.target.closest('cart-remove-button');
        if (!removeBtn) return;

        const cartItemEl = removeBtn.closest('[data-cart-item]');
        if (!cartItemEl) return;

        const parentVariantId = cartItemEl.dataset.variantId;

        const cart = await fetch('/cart.js').then(res => res.json());

        const updates = {};

        cart.items.forEach((item, index) => {
          const isParent = item.id == parentVariantId;

          const isChild =
            item.properties &&
            item.properties.parent_id &&
            item.properties.parent_id == parentVariantId;

          if (isParent || isChild) {
            updates[index + 1] = 0;
          }
        });

        // Only override if it has children
        if (Object.keys(updates).length > 1) {
          e.preventDefault();

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
      }

      refreshCartDrawer() {
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      setLoading(state) {
        if (!this.submitButton) return;

        this.submitButton.disabled = state;
        this.submitButton.classList.toggle('loading', state);
      }
    }
  );
}*/
/*if (!customElements.get('product-wellness-form')) {
  customElements.define(
    'product-wellness-form',
    class ProductWellnessForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-add-to-cart]');

        if (!this.form || !this.submitButton) return;

        this.onSubmitHandler = this.onSubmit.bind(this);
        this.submitButton.addEventListener('click', this.onSubmitHandler);
      }

      disconnectedCallback() {
        if (this.submitButton) {
          this.submitButton.removeEventListener('click', this.onSubmitHandler);
        }
      }

      getSelectedItems() {
        const inputs = this.querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        );

        return Array.from(inputs).map((input) => {
          return {
            id: parseInt(input.value),
            quantity: 1
          };
        });
      }

      async onSubmit() {
        const items = this.getSelectedItems();

        if (!items.length) {
          alert('Please select at least one product');
          return;
        }

        this.setLoading(true);

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Cart request failed');

          await response.json();

          this.refreshCartDrawer();

        } catch (error) {
          console.error('Error:', error);
        } finally {
          this.setLoading(false);
        }
      }

      refreshCartDrawer() {
        // Trigger Dawn cart refresh
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        // Open cart drawer if exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      setLoading(state) {
        if (!this.submitButton) return;

        this.submitButton.disabled = state;
        this.submitButton.classList.toggle('loading', state);
      }
    }
  );
}*/